import { RouteFragment } from '../RouteFragment';

export abstract class RouteSearchResults extends RouteFragment {
	protected async selfRouteComponent(): Promise<any> {
		return import('@/presentation/components/organisations/Organisations.vue');
	}
}
